"use client";

import { Core } from "@faire/design-tokens";
import * as React from "react";

import { Eye } from "../../icons/foundation/Eye";
import { Input, IProps } from "../index";

/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/component/input/web/password-input)
 */
export const PasswordInput: React.FC<IProps> = (props) => {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <Input
      {...props}
      suffixNode={
        <EyeButton
          onClick={() => setShowPassword(!showPassword)}
          closed={!showPassword}
        />
      }
      type={showPassword ? "text" : "password"}
      spellCheck={false}
      autoComplete="off"
    />
  );
};

/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/IconButton/IconButton#IconButton"
 */
const EyeButton: React.FC<{
  closed: boolean;
  onClick: () => void;
}> = ({ closed, onClick }) => (
  <button
    onClick={onClick}
    aria-label="Show Password"
    data-test-id="showPasswordButton"
  >
    <Eye color={Core.icon.default} closed={closed} />
  </button>
);
